import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { useState } from "react";
import QRCode from "react-qr-code";
import { IoMdClose } from "react-icons/io";

export default function QrCodeModal({ surveyID, value, onClose = () => null }) {
  const qrCodeID = `qr-code-${surveyID}`;

  const [config, setConfig] = useState({
    fgColor: "#000",
    bgColor: "#fff",
    isBgTransparent: false,
    size: 256,
  });

  const handleDownloadQrCode = () => {
    const svg = document.getElementById(qrCodeID);
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = `QR Code live ${surveyID}`;
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };

    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  return (
    <Dialog fullWidth maxWidth="md" open={value} onClose={onClose}>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>QR Code da Live</span>
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
            }}
            onClick={onClose}
          >
            <IoMdClose size="1.25em" />
          </button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ margin: "0 auto", maxWidth: "20rem" }}>
          <QRCode
            id={qrCodeID}
            title="QR Code da live"
            value={value}
            size={config.size}
            fgColor={config.fgColor}
            bgColor={config.isBgTransparent ? "#00000000" : config.bgColor}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              marginTop: "2rem",
            }}
          >
            <label
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.25rem",
              }}
            >
              <span>Tamanho do QR Code (px)</span>
              <input
                type="number"
                value={config.size}
                onChange={(e) => {
                  e.persist();

                  setConfig((prev) => ({ ...prev, size: e.target.value }));
                }}
              />
            </label>
            <label
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.25rem",
              }}
            >
              <span>Cor do QR Code (hex)</span>
              <input
                placeholder="Ex: #000 (preto)"
                value={config.fgColor}
                onChange={(e) => {
                  e.persist();

                  setConfig((prev) => ({ ...prev, fgColor: e.target.value }));
                }}
              />
            </label>
            <label
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.25rem",
              }}
            >
              <span>Fundo do QR Code (hex)</span>
              {!config.isBgTransparent && (
                <input
                  placeholder="Ex: #000 (preto)"
                  value={config.bgColor}
                  onChange={(e) => {
                    e.persist();

                    setConfig((prev) => ({ ...prev, bgColor: e.target.value }));
                  }}
                />
              )}
              <label
                style={{ display: "flex", gap: "0.25rem", fontSize: "0.8rem" }}
              >
                <input
                  type="checkbox"
                  value={config.isBgTransparent}
                  onChange={(e) => {
                    e.persist();

                    setConfig((prev) => ({
                      ...prev,
                      isBgTransparent: e.target.checked,
                    }));
                  }}
                />
                <span>Fundo Transparente?</span>
              </label>
            </label>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          onClick={handleDownloadQrCode}
        >
          Baixar QR Code
        </Button>
      </DialogActions>
    </Dialog>
  );
}
